import { render, staticRenderFns } from "./pay-popup.vue?vue&type=template&id=af89cf8c&scoped=true&"
import script from "./pay-popup.vue?vue&type=script&lang=js&"
export * from "./pay-popup.vue?vue&type=script&lang=js&"
import style0 from "./pay-popup.vue?vue&type=style&index=0&id=af89cf8c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/_vue-loader@15.10.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "af89cf8c",
  null
  
)

export default component.exports